module.exports = __webpack_public_path__ + "img/renew.290ca09e.png";